import { darken, lighten, useTheme } from '@mui/material';

import { useDataGridCommonStyles } from '~/components/SolaForceDataGrid/hooks/useDataGridCommonStyles';

export const useStyles = () => {
  const theme = useTheme();
  const { autoRowHeightPadding } = useDataGridCommonStyles();

  const getBackgroundColor = (color: string) =>
    theme.palette.mode === 'dark' ? darken(color, 0.7) : lighten(color, 0.7);

  const getHoverBackgroundColor = (color: string) =>
    theme.palette.mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.6);

  const getSelectedBackgroundColor = (color: string) =>
    theme.palette.mode === 'dark' ? darken(color, 0.5) : lighten(color, 0.5);

  const getSelectedHoverBackgroundColor = (color: string) =>
    theme.palette.mode === 'dark' ? darken(color, 0.4) : lighten(color, 0.4);

  const getRowBackground = (color: string) => {
    return {
      backgroundColor: getBackgroundColor(color),
      '&:hover': {
        backgroundColor: getHoverBackgroundColor(color),
      },
      '&.Mui-selected': {
        backgroundColor: getSelectedBackgroundColor(color),
        '&:hover': {
          backgroundColor: getSelectedHoverBackgroundColor(color),
        },
      },
    };
  };

  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
    },
    dataGrid: {
      '& .multiline-description .MuiDataGrid-cellContent': {
        whiteSpace: 'pre-wrap',
      },
      '& .row-type-list': {
        ...getRowBackground(theme.palette.grey.A400),
      },
      ...autoRowHeightPadding,
    },
  };
};
